import { render, staticRenderFns } from "./QuoteWizardModuleConfigurationDialog.vue?vue&type=template&id=90ecf408&scoped=true&"
import script from "./QuoteWizardModuleConfigurationDialog.vue?vue&type=script&lang=ts&"
export * from "./QuoteWizardModuleConfigurationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteWizardModuleConfigurationDialog.vue?vue&type=style&index=0&id=90ecf408&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ecf408",
  null
  
)

export default component.exports